export interface DiagResourcesResponse {
    resourcesInfoVersion: string;
    updated: string;
    forms: { [gfv: string]: unknown };
}
